import LEPIcon from './component'

export default LEPIcon
